/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import axios from "axios";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState, useEffect } from "react";

import MDBackdrop from "components/MDBackdrop";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import { useMaterialUIController } from "context";
import theme from "assets/theme";

import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Completion from "./Completion";
import useApiRequest from "utils/Apirequest";
import { Autocomplete, TextField } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { allowOnlyAlphanumericAndSpace } from "utils/Constant";
import { isValidEmail } from "utils/Constant";

import { isValidPhone } from "utils/Constant";


const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    phoneNumber: "",
    password: "",
    locationId: "",
};

function PopAddSupervisor(props) {
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;
    const [showPassword, setShowPassword] = useState(false);
    const apiRequest = useApiRequest();
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState(initialValues);
    const { enqueueSnackbar } = useSnackbar();
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [locationsFetched, setLocationsFetched] = useState(false);



    const fetchLocations = async () => {
        setLoadingLocations(true);
        const { data } = await apiRequest('get', 'charger-locations/location-id-name', null,
            {},
            {}, false
        ) || {};
        if (data?.status || data?.success) {
            setLocations(data?.data);
            setLocationsFetched(true);
            setLoadingLocations(false);
        }
        else {
            setLoadingLocations(false);
        }
    }

    const createUser = async () => {
        onClose(false);

        const payload = {
            firstName: values?.first_name,
            lastName: values?.last_name,
            email: values?.email,
            phoneNumber: values?.phoneNumber,
            password: values?.password,
            locationId: values?.locationId,
        };
        const { data } =
            (await apiRequest(
                "post",
                "supervisor",
                payload,
                {},
                {
                    "Content-Type": "application/json",
                }
            )) || {};
        if (data?.success || data?.status) {
            setIsDisabled(!isDisabled);
        }
    };


    const handleChange = (event) => {
        setValues((prevValues) => ({
            ...prevValues,
            [event.target.name]: event.target.value,
        }));
    };

    const reset = (event) => {
        event.preventDefault();
        setValues(props.value);
    };
    const handleClose = () => {
        onClose(false);
    };




    const pop = () => {
        values.locationId = selectedLocation?._id;
        if (!values.first_name || !values.phoneNumber || !values.password || !values.email || !values.last_name || !values.locationId) 
            return enqueueSnackbar("Please Fill All Necessary Details !!!", {
                variant: "error",
                autoHideDuration: 2000,
            });

        const passwordRegex = /^(?=.*[A-Z]).{8,}$/;
        if (!passwordRegex.test(values?.password)) {
            return enqueueSnackbar(
                "Password must contain at least one uppercase letter, one lowercase letter, and be a minimum of 8 characters.",
                { variant: "error", autoHideDuration: 2000 }
            );
        }

        setIsBackdrop(false);
        onClose(false);
        createUser();
    };

    return (
        <>
            <Completion
                isDialog={isDisabled}
                onClose={setIsDisabled}
            />
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog
                open={props.isDialog}
                onClose={handleClose}
                fullWidth={false} // stop stretching
                PaperProps={{
                    sx: {
                        width: 1000, // exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }}
            >
                <DialogTitle
                    style={
                        darkMode
                            ? {
                                backgroundColor: "#202940",
                                color: "#ffffff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }
                            : {
                                theme,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }
                    }
                >
                    Add Supervisor
                    <IconButton
                        aria-label="delete"
                        onClick={handleClose}
                        style={darkMode ? { color: "#ffffff" } : theme}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    style={
                        darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme
                    }
                >
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox pt={0}></MDBox>

                        <MDBox p={2} component="form" role="form">
                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="First Name"
                                    name="first_name"
                                    value={values.first_name}
                                    margin="dense"
                                    fullWidth
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            first_name: allowOnlyAlphanumericAndSpace(value)
                                                ? ""
                                                : "Only letters are allowed",
                                        }));
                                    }}
                                    error={Boolean(errors.first_name)}
                                    helperText={errors.first_name}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="text"
                                    label="Last Name"
                                    name="last_name"
                                    value={values.last_name}
                                    margin="dense"
                                    fullWidth
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            last_name: allowOnlyAlphanumericAndSpace(value)
                                                ? ""
                                                : "Only letters are allowed",
                                        }));
                                    }}
                                    error={Boolean(errors.last_name)}
                                    helperText={errors.last_name}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>

                            <MDBox p={1}>
                                <MDInput
                                    type="email"
                                    label="E-mail ID"
                                    name="email"
                                    value={values.email}
                                    placeholder="username@gmail.com"
                                    margin="dense"
                                    fullWidth
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            email: isValidEmail(value)
                                                ? ""
                                                : "Enter a valid email address",
                                        }));
                                    }}
                                    error={Boolean(errors.email)}
                                    helperText={errors.email}
                                    FormHelperTextProps={{
                                        sx: {
                                            color: "#d32f2f",
                                            fontSize: "12px",
                                            marginLeft: "4px",
                                        },
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>
                                <MDInput
                                    type="tel"
                                    label="Phone Number"
                                    value={values.phoneNumber}
                                    name="phoneNumber"
                                    fullWidth
                                    onChange={handleChange}
                                    onBlur={(e) => {
                                        const value = e.target.value;

                                        setErrors((prev) => ({
                                            ...prev,
                                            phoneNumber: isValidPhone(value)
                                                ? ""
                                                : "Enter a valid Phone Number",
                                        }));
                                    }}
                                    error={Boolean(errors.phoneNumber)}
                                    helperText={errors.phoneNumber}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            color: "error.main",
                                        },
                                        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "error.main",
                                        },
                                    }}
                                />
                            </MDBox>
                            
              
                            <MDBox p={1}>
                                <MDInput
                                    type={showPassword ? "text" : "password"}
                                    label="Password"
                                    value={values.password}
                                    name="password"
                                    margin="dense"
                                    fullWidth={true}
                                    onChange={(event) => {
                                        handleChange(event);
                                    }}
                                    InputProps={{
                                        endAdornment: values.password && (
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                                edge="end"
                                            >
                                                {showPassword ? (
                                                    <VisibilityOffIcon />
                                                ) : (
                                                    <VisibilityIcon />
                                                )}
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </MDBox>
                            <MDBox p={1}>

                                <Autocomplete
                                    options={locations}
                                    loading={loadingLocations}
                                    getOptionLabel={(option) => option.locationName || ""}
                                    isOptionEqualToValue={(option, value) => option._id === value._id}
                                    value={selectedLocation}
                                    onChange={(event, newValue) => {
                                        setSelectedLocation(newValue);
                                        console.log("Selected Location ID:", newValue?._id);
                                    }}
                                    onOpen={() => {
                                        if (!locationsFetched) {
                                            fetchLocations();
                                        }
                                    }}
                                    sx={{ width: "100%" }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Location"
                                            size="small"
                                            sx={{
                                                backgroundColor: "#fff",
                                                borderRadius: "6px",
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "#fff",
                                                    height: 37,
                                                    paddingRight: "8px",
                                                },
                                                "& .MuiOutlinedInput-input": {
                                                    padding: "10px 14px",
                                                },

                                            }}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loadingLocations ? <CircularProgress size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </MDBox>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions
                    style={
                        darkMode
                            ? {
                                backgroundColor: "#202940",
                                justifyContent: "space-evenly",
                                color: "#ffffff",
                            }
                            : { theme, justifyContent: "space-evenly" }
                    }
                >
                    <MDButton variant="gradient" color={sidenavColor} onClick={reset}>
                        Reset
                    </MDButton>
                    <MDButton variant="gradient" color={sidenavColor} onClick={pop}>
                        Submit
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddSupervisor;
